<a href="javascript:;" (click)="close()" class="close-btn"><i class="far fa-times"></i></a>
<div class="modal-body bg-none d-flex flex-column align-items-center m-0 px-5 py-4 gap-3">
  <img src="/assets/images/messaging/whatsapp-chat.webp" alt="" style="width: 12rem" />
  <h5 class="mb-0">
    <ng-container i18n>Connect WhatsApp for</ng-container>&nbsp;<span class="text-whatsapp" i18n>Free</span
    >&nbsp;<ng-container i18n>Guest Messaging</ng-container>
  </h5>
  <p class="mb-0" i18n>
    Stay connected with guests effortlessly! Integrate WhatsApp into your Unified Inbox and start messaging for free.
    Track conversations, automate replies, and streamline communication—all in one place.
  </p>

  <div class="d-flex gap-3 w-100">
    <div class="flex-1">
      <form novalidate>
        <app-phone-number-input
          [ctrl]="form.get('whatsapp_phone')"
          [showLabel]="true"
          [showPrefix]="true"
          label="Please enter Guest WhatsApp number"
          i18n-label
          i18n-placeholder
          placeholder="WhatsApp number"
          matTooltip="Enter guest WhatsApp number to receive and send messages from the Unified Inbox"
          i18n-matTooltip
        ></app-phone-number-input>
      </form>
    </div>
    <div class="flex-1">
      <button
        class="btn btn-secondary w-100 align-input-row-end"
        (click)="onConnect(form)"
        matTooltip="Ensure Guest WhatsApp number is validated before connecting."
        i18n-matTooltip
      >
        <i class="fab fa-whatsapp text-xxl"></i> <ng-container i18n>Connect WhatsApp Now</ng-container>
      </button>
      <div class="text-muted text-sm" i18n>100% Free - No Subscription, No Hidden Fees!</div>
    </div>
  </div>
</div>
